import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  PageContent,
  CustomBreadcrumb,
  CustomButton,
  showToast,
} from "components/Common";
import Table, { scrollToTopRow } from "components/Common/Table";
import { DELAY_FETCH, ModuleIds } from "constant";
import SiteService from "services/Site";
import { GetDataDepartmentSites } from "helpers/app-backend/testlistdepartmentsitebackend_helper";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Filter from "./Filter";
import getColumns from "./columns";

const RESOURCE = ModuleIds.TestListDepartmentSite;

const TestListDepartmentSiteContainer = ({ t }) => {
  const titleTag = t("Danh sách xét nghiệm khoa phòng trên site");

  const timerRef = useRef(null);
  const [listTestListDepartmentSite, setListTestListDepartmentSite] = useState(
    []
  );
  const [filter, setFilter] = useState({
    siteCode: "",
  });
  const [loading, setLoading] = useState(false);
  const [sites, setSites] = useState([]);
  const [error, setError] = useState(null);

  const [paging, setPaging] = useState({
    currentPage: 1,
    pageSize: 100,
  });
  const onGetDataFilter = async () => {
    const res = await SiteService.getListSite({
      page: 1,
      size: 1000,
      search: "",
    });
    let result = res?.data.map(
      item =>
        (item = {
          value: item.fullNameSchema,
          label: item.fullNameSite,
        })
    );
    setSites(result);
  };
  const onValidation = () => {
    const err = {};
    if (!filter.dateFrom || !filter.dateTo) {
    } else if (filter.dateFrom.getTime() > filter.dateTo.getTime()) {
      err.date = "Ngày bắt đầu <= ngày kết thúc";
    }
    if (
      (!filter.countTestFrom && filter.countTestFrom !== 0) ||
      (!filter.countTestTo && filter.countTestTo !== 0)
    ) {
    } else if (filter.countTestFrom > filter.countTestTo) {
      err.count = "CountTest From <= To";
    }

    return err;
  };
  const onGetListTestListDepartmentSite = async () => {
    if (!filter.siteCode) {
      showToast("Bạn phải chọn Site trước khi tìm kiếm", 2);
      setListTestListDepartmentSite([]);
      return;
    }
  
    const err = onValidation();
    if (JSON.stringify(err) !== "{}") {
      setError(err);
      return;
    }
  
    setLoading(true);
  
    timerRef.current = setTimeout(async () => {
      const res = await GetDataDepartmentSites({
        page: paging.currentPage,
        pageSize: paging.pageSize,
        ...filter,
      });
  
      if (res.error) {
        showToast(`${res.error.title}: ${res.error.description}`, 3);
        setListTestListDepartmentSite([]);
        setLoading(false);
        return;
      }
  
      setListTestListDepartmentSite(res || []);
      setLoading(false);
      scrollToTopRow();
    }, DELAY_FETCH);
  };
  

  useEffect(() => {
    onGetListTestListDepartmentSite();
  }, [paging]);

  useMemo(() => {
    onGetDataFilter();
  }, []);
  return (
    <PageContent title={t(titleTag)}>
      <CustomBreadcrumb
        breadcrumbItem={titleTag}
        resource={RESOURCE}
        icon={<i className="bx bx-file" />}
      />
      <Filter
        filter={filter}
        setFilter={setFilter}
        sites={sites}
        paging={paging}
        setPaging={setPaging}
      />
      <Table
        paging={paging}
        setPaging={setPaging}
        data={listTestListDepartmentSite}
        pageSize={paging.pageSize}
        style={{ height: "calc(100vh - 390px)" }}
        columns={getColumns({ t })}
        loading={loading}
      />
    </PageContent>
  );
};

TestListDepartmentSiteContainer.propTypes = {
  t: PropTypes.any,
};

export default withRouter(
  withTranslation(["sitePage", "UserPage", "message"])(
    TestListDepartmentSiteContainer
  )
);
